import p from './paste';

export * from './paste';
export default p;
